import { useMemo } from 'react';
import { useSplunkLogger } from './splunk-provider';
export function useSplunkActivityLogger() {
    const logger = useSplunkLogger();
    return useMemo(() => ({
        logFileUpload({ cedantId, directoryPath, fileCount, fileNames }) {
            logger.info('File upload', { eventCategory: 'file_operation', cedantId, directoryPath, fileCount, fileNames });
        },
        logFolderCreate({ cedantId, parentPath, folderName }) {
            logger.info('Folder create', { eventCategory: 'file_operation', cedantId, parentPath, folderName });
        },
        logFileDownload({ cedantId, fileId, fileName }) {
            logger.info('File download', { eventCategory: 'file_operation', cedantId, fileId, fileName });
        },
        logFolderDownload({ cedantId, directoryId, folderName }) {
            logger.info('Folder download', { eventCategory: 'file_operation', cedantId, directoryId, folderName });
        },
        logFileMove({ cedantId, fileIds, sourceDirectory, destinationDirectory }) {
            logger.info('File move', { eventCategory: 'file_operation', cedantId, fileIds, sourceDirectory, destinationDirectory });
        },
        logFileRename({ cedantId, fileId, originalName, newName }) {
            logger.info('File rename', { eventCategory: 'file_operation', cedantId, fileId, originalName, newName });
        },
        logFileDelete({ cedantId, fileId, fileName }) {
            logger.info('File delete', { eventCategory: 'file_operation', cedantId, fileId, fileName });
        },
        logFileArchive({ cedantId, fileId, fileName }) {
            logger.info('File archive', { eventCategory: 'file_operation', cedantId, fileId, fileName });
        },
        logFileSearch({ cedantId, query }) {
            logger.info('File search', { eventCategory: 'file_search', cedantId, query });
        },
        logUploadValidationError({ cedantId, errorCode, fileNames }) {
            logger.warn('Upload validation error', { eventCategory: 'file_validation', cedantId, errorCode, fileNames });
        },
        logActivityFeedOpen({ cedantId }) {
            logger.info('Activity feed open', { eventCategory: 'activity_feed', cedantId });
        },
        logActivityFeedFilter({ cedantId, eventType }) {
            logger.info('Activity feed filter', { eventCategory: 'activity_feed', cedantId, eventType });
        },
        logActivityFeedPaginate({ cedantId, cursor }) {
            logger.info('Activity feed paginate', { eventCategory: 'activity_feed', cedantId, cursor });
        },
        logPiiJustify({ cedantId, fileId, fileName }) {
            logger.info('PII justify', { eventCategory: 'pii_review', cedantId, fileId, fileName });
        },
        logPiiApprove({ cedantId, fileId, fileName }) {
            logger.info('PII approve', { eventCategory: 'pii_review', cedantId, fileId, fileName });
        },
        logNavigation({ from, to }) {
            logger.info('Navigation', { eventCategory: 'navigation', from, to });
        },
        logFileDetailsView({ cedantId, fileId }) {
            logger.info('File details view', { eventCategory: 'navigation', cedantId, fileId });
        },
        logUserAdd({ actionType, targetRole }) {
            logger.info('User add', { eventCategory: 'user_management', actionType, targetRole });
        },
        logUserModify({ actionType, changeDescription }) {
            logger.info('User modify', { eventCategory: 'user_management', actionType, changeDescription });
        },
    }), [logger]);
}
